import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import { useContext, useEffect } from "react";
import { LoadingContext } from "../context/LoadingContext";
import Loading from "../components/common/Loaing";

const AdminLayout = () => {
  const { loading, setLoading } = useContext(LoadingContext);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
    }
  }, []);

  return (
    <div className="w-full max-w-[1920px] mx-auto min-h-screen bg-main-background">
      {loading ? (
        <div className="flex items-center justify-center min-h-screen">
          <Loading />
        </div>
      ) : (
        <>
          <header>
            <Navbar />
          </header>

          <main>
            <Outlet />
          </main>
        </>
      )}

    </div>
  );
};

export default AdminLayout;